import React from 'react'
import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'
import { memo } from '~/ui/component'
import { HBox, Label, SVG, TextBlock, VBox } from '~/ui/components'
import { layout } from '~/ui/styling'
import { BeWizrEnrollmentStatus, BeWizrTile } from '../bewizr'

export interface Props {
  id:               string
  label?:           string
  title:            string
  startDate?:       DateTime | null
  itemCount?:       number
  isEnrolled?:      boolean
  isOnWaitingList?: boolean
  placesLeft?:      number | null
  mayEnroll?:       boolean
  image:            string | null
  description?:     string | null
  horizontal?:      boolean
}

const BeWizrLearningTrackTile = memo('BeWizrLearningTrackTile', (props: Props) => {

  const {
    label,
    title,
    startDate,
    id,
    image,
    isEnrolled = false,
    isOnWaitingList = false,
    placesLeft = null,
    mayEnroll,
    description,
    horizontal,
  } = props

  const [t, i18next] = useTranslation('bewizr-learning-tracks')

  const showStatus = isEnrolled || isOnWaitingList || mayEnroll

  //------
  // Rendering

  function render() {
    return (
      <BeWizrTile
        label={label}
        icon={'unordered-list'}
        detail={renderInfo()}
        title={title}
        subtitle={renderStatus()}
        href={`//bewizr-learning-track/${id}`}
        buttonCaption={t('view')}
        image={image}
        horizontal={horizontal}
        children={renderDescription()}
      />
    )
  }

  function renderInfo() {
    if (startDate == null) { return null }

    return (
      <VBox gap={layout.padding.inline.s} align='left'>
        <HBox gap={layout.padding.inline.s}>
          <SVG name='calendar' dim size={layout.icon.s}/>
          <Label tiny>
            {startDate.toFormat('d-M-yyyy', {locale: i18next.language})}
          </Label>
        </HBox>
        <HBox gap={layout.padding.inline.s}>
          <SVG name='clock' dim size={layout.icon.s}/>
          <Label tiny>
            {startDate.toFormat('HH:mm', {locale: i18next.language})}
          </Label>
        </HBox>
      </VBox>
    )
  }

  function renderStatus() {
    if (!showStatus) { return null }
    return (
      <BeWizrEnrollmentStatus
        isEnrolled={isEnrolled}
        isOnWaitingList={isOnWaitingList}
        placesLeft={placesLeft}
        small
      />
    )
  }

  function renderDescription() {
    if (description == null) { return null }

    return (
      <TextBlock small dim>
        {description}
      </TextBlock>
    )
  }

  return render()

})

export default BeWizrLearningTrackTile